import React,{useState,useEffect} from 'react';
//import FormHelperText from '@mui/material/FormHelperText';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Hidden from '@mui/material/Hidden';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import Badge from '@mui/material/Badge';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';
import {Tools} from './Tools';
import {Item,Kbin,Owner} from './Inc';
import MultiLines from './MultiLines';
import StoreImg from './StoreImg';
import useStyles from './Styles';

interface Props {
	isOpen:boolean,
    items:Item[],
    owner:Owner,
    kbin:Kbin,
    next(selectedItems:Item[]):void,
    close(): void,
}

const KbinItems = (props:Props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));

    const [selected,setSelected] = useState([] as number[]);
    const change = (index:number)=> {
        //console.log(selected);
        if( selected.includes(index) ){
            setSelected(prevSelected => prevSelected.filter((value)=>value!==index));
        } else {
            setSelected(prevSelected => [...prevSelected, index]);
        }
    }

	const send= ()=>{
        const items = [] as Item[];
        selected.forEach((index)=>items.push(props.items[index]));
        props.next(items);
    }

	useEffect(()=>{
		if(props.isOpen){
			setSelected([] as number[]);
		}
	},[props.isOpen]);

	if(!props.isOpen){
		return (null);
	}

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			fullScreen={fullScreen}
		>
			<DialogTitle color='primary'>参加作品の選択</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
					<MultiLines text={props.kbin.requirements}/>
				</div>
				<div style={{marginBottom:"2em"}}>
					<Table>
						<TableHead>
							<TableRow>
                                <TableCell className={classes.tableHeadNowrap} align="center"></TableCell>
                                <TableCell className={classes.tableHeadNowrap} align="center">画像</TableCell>
                                <TableCell className={classes.tableHeadNowrap} align='center'>商品</TableCell>
								<TableCell className={classes.tableHeadNowrap} align='center'>在庫</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
					{props.items.map( (item:Item,index:number)=>{
						const key = "item"+index;
						return (
							<TableRow key={key} onClick={()=>change(index)} sx={{cursor:'pointer','&:hover':{backgroundColor:'#E5FFEE'}}}>
                                <TableCell className={classes.tableCellDense} align="center"><Checkbox checked={selected.includes(index)} style={{margin:0,padding:0}}/></TableCell>
								<TableCell className={classes.tableCellDense} align="center"><StoreImg owner_id={props.owner.owner_id} img_id={item.img_id} thumb={true} className="imgList"/></TableCell>
								<TableCell className={classes.tableCellDense}>
									<span className={classes.itemId}>ID:{item.item_id}</span>　
									<Hidden smUp implementation="js">
										<br/>
									</Hidden>
									{item.item_name}
								</TableCell>
								<TableCell className={classes.tableCellNowrap} align="right">{item.num_stock}</TableCell>
							</TableRow>
						);
					})}
						</TableBody>
					</Table>
					{props.items && props.items.length===0 && 
					<div style={{textAlign:'center',margin:'2em 0',color:'brown'}}>
						<SearchOffIcon style={{fontSize:'300%'}}/><br/>条件に合う作品がありません
					</div>
					}

				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<FormControl fullWidth={true} style={{marginLeft:'0.5em'}}>
				<div style={{marginTop:`0em`,marginBottom:`0em`,textAlign:'right',position:'relative'}}>
					<Button variant="text" color="primary" onClick={props.close} style={{marginRight:'0.25em'}}>中断する</Button>
					<Badge color="success" badgeContent={selected.length}>
						<Button variant="contained" color="primary" onClick={send} disabled={selected.length>props.kbin.entry_count}>決定する</Button>
					</Badge>
				</div>
				</FormControl>
			</DialogActions>
		</Dialog>
	);
}

export default KbinItems;
